export default "__VITE_ASSET__jaXzPbXB__"